import { MIN_LABELED_BAR_SIZE } from '../xy-chart/constants/defaults.js';

/** @internal */
export const ROW_HEIGHT = MIN_LABELED_BAR_SIZE;

/** @internal */
export const SERIES_ID_KEY = '__toplist_series_id__';

/** @internal */
export const SERIES_NAME_KEY = '__toplist_series_name__';

/** @internal */
export const ROW_KEY = '__toplist_row_key__';

/** @internal */
export const X_AXIS_ID = 'toplist-x';

/** @internal */
export const Y_AXIS_ID = 'toplist-y';

/** @internal */
export const TOP_LIST_ARIA_LABEL = 'Top List';
